export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_CART_TICKETS_PATH = '/cart/get-cart';
export const CART_TICKETS_REQUEST_NAME = 'CART_TICKETS_REQUEST';
export const AUTH_REQUEST_NAME = 'AUTH_REQUEST_NAME';

export const BASE_DELETE_CART_PATH = '/cart/delete';
export const BASE_SAVE_CONTACT_DETAILS_PATH = '/cart/save-contact-details';
export const BASE_BUY_TICKETS_PATH = '/cart/buy-tickets';
export const BASE_RESTORE_CART_PATH = '/cart/restore-cart';
